import PopupManager from "element-ui/lib/utils/popup/popup-manager";

/**
 * 交互包等 Drawer/Dialog 嵌套关闭后，Element UI 可能残留 v-modal。
 * 残留遮罩点一下会把后续真正打开的弹窗立刻关掉。
 */
export function cleanupElementPopups() {
  if (typeof document === "undefined") {
    return;
  }
  try {
    const stack = PopupManager.modalStack;
    if (stack && stack.length) {
      stack
        .slice()
        .reverse()
        .forEach((item) => {
          if (item && item.id) {
            PopupManager.closeModal(item.id);
          }
        });
      stack.splice(0, stack.length);
    }
    const modalDom = PopupManager.modalDom;
    if (modalDom) {
      if (modalDom.parentNode) {
        modalDom.parentNode.removeChild(modalDom);
      }
      modalDom.style.display = "none";
      PopupManager.modalDom = undefined;
    }
  } catch (e) {
    /* ignore */
  }
  document.querySelectorAll("body > .v-modal").forEach((n) => {
    if (n.parentNode) {
      n.parentNode.removeChild(n);
    }
  });
  document.body.classList.remove("el-popup-parent--hidden");
  document.body.style.removeProperty("overflow");
  document.body.style.removeProperty("padding-right");
  document.body.style.removeProperty("width");
}
